import { Routes, Route,  Navigate, useNavigate } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import ProductsPage from './pages/ProductsPage'
import TrainingPage from './pages/TrainingPage'
import SupportPage from './pages/SupportPage'
import CorporatePage from './pages/CorporatePage'
import PhilosophyPage from './pages/Philosophypage'
import NotFoundPage from './pages/NotFoundPage'
import ScramblerDemoPage from './pages/products/ScramblerDemoPage'
import LeadershipPage from './pages/corporate/LeadershipPage'
import AIOperationsPage from './pages/AIOperationsPage'
import DemoPage from './pages/DemoPage'
import ServicesPage from './pages/ServicesPage'

import { CookieConsentProvider } from './context/CookieConsentContext'
import CookieConsentBanner from './components/Cookieconsentbanner'
import CookiePreferencesModal from './components/Cookiepreferencesmodal'
import GraffitiScramblerProduct from './components/GraffitiScramblerProduct';

//23Controls Interface Imports for AWS & Google Identity Services
import Dashboard from './components/Dashboard.jsx';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import OAuthCallback from './pages/OAuthCallback';

//Stripe Imports
import StripeCheckout from './components/StripeCheckout';
import SubscriptionCheckout from './components/SubscriptionCheckout';
import CheckoutSuccess from './components/CheckoutSuccess';
import './styles/stripe-checkout.css';


// Product page component
const ProductPage = () => {
  return (
    <div>
      {/* Your existing header/nav here */}
      
      <GraffitiScramblerProduct />
      
      {/* Your existing footer here */}
    </div>
  );
};

function App() {
  return (

    <CookieConsentProvider>
      <Routes>
                {/* Hardware Store */}
        <Route path="/store" element={<StripeCheckout />} />       
        {/* Subscription Plans */}
        <Route path="/subscriptions" element={<SubscriptionCheckout />} />
        <Route path="/login" element={<LoginPage />} />
        {/* Success Pages */}
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/subscription/success" element={<CheckoutSuccess />} /> 
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="products/*" element={<ProductsPage />} />
          <Route path="products/home/demo" element={<ScramblerDemoPage />} />
          <Route path="products/devices/graffiti-scrambler" element={<ProductPage />} />
          <Route path="ai-operations/*" element={<AIOperationsPage />} />
          <Route path="demo" element={<DemoPage />} />
          <Route path="services/*" element={<ServicesPage />} />
          {/* /models and /research used to be a fabricated "150+ models"
              marketplace and invented research papers — no real content
              exists behind either, and neither is linked from nav anymore.
              Redirecting old links/bookmarks rather than leaving fake
              content reachable. */}
          <Route path="models/*" element={<Navigate to="/products" replace />} />
          <Route path="research/*" element={<Navigate to="/philosophy" replace />} />
          <Route path="training/*" element={<TrainingPage />} />
          <Route path="support/*" element={<SupportPage />} />
          <Route path="corporate/*" element={<CorporatePage />} />
          <Route path="corporate/company/leadership" element={<LeadershipPage />} />
          <Route path="philosophy" element={<PhilosophyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route 
            path="/oauth/callback" 
            element={<OAuthCallback />} 
        />
        <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
        />
      </Routes>
      {/* Cookie Consent Components */}
      <CookieConsentBanner />
      <CookiePreferencesModal />
    </CookieConsentProvider>
  )
}
export default App
